export default __webpack_public_path__ + "static/media/staking pig_grey 1.33d7e228.svg";